import React from "react";
import MetisMenu from 'react-metismenu';
import RouterLink from 'react-metismenu-router-link';
import '../../Styles/react-metismenu-standart.css';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

const menuAdmin=[
    {
        label: 'translations',
        to: '/orderList',
    },
	{
        label: 'quotations',
        to: '/quotationList',
    },
	{
        label: 'users',
        to: '/userList',
    },
	{
        label: 'hhrr',
        to: '/curriculumList',
    },
	{
        label: 'raters',
        to: '/raters',
    },
	{
        label: 'customers',
        to: '/customerList',
    },
	{
        label: 'tmx',
        to: '/tmxList',
    },
	{
        label: 'nonconformities',
        to: '/nonconformityList',
    },
	{
        label: 'alerts',
        to: '/alertList',
    },
	{
        label: 'configuration',
        to: '/config',
    },

];

const menuTranslator=[
    {
        label: 'translations',
        to: '/orderList',
    },
	{
        label: 'tmx',
        to: '/tmxList',
    },
	{
        label: 'billing',
        to: '/billing',
    },
];

const menuCustomer=[
    {
        label: 'translations',
        to: '/orderList',
    },
	{
        label: 'upload_file',
        to: '/orderNew',
    },
	{
        label: 'send_short_texts',
        to: '/sendText',
    },
	{
        label: 'quotations',
        to: '/quotationList',
    },
	{
        label: 'new_quotation',
        to: '/quotationNew',
    },
	{
        label: 'billing',
        to: '/billing',
    },
];

const menuConcursor=[
    {
        label: 'curriculums',
        to: '/curriculumList',
    },
];

const menuProjectManager=[
    {
        label: 'translations',
        to: '/orderList',
    },
];

const Menu = (props) => {
	const { t, i18n } = useTranslation()
	
	var menuContent;
	let cssPrefix="";
	switch(props.role) {
		case 'ADMIN':
			menuContent = menuAdmin;
			break;
		case 'TRANSLATOR':
			menuContent = menuTranslator;
			break;
		case 'CUSTOMER':
			menuContent = menuCustomer;
			break;
		case 'CONCURSOR':
			menuContent = menuConcursor;
			break;
		case 'PROJECT_MANAGER':
			menuContent = menuProjectManager;
			break;
		default:
			menuContent = [];
	}
	
	switch (props.multiplataforma) {
		case 'indra':
			cssPrefix = 'indra-'
			break;
		case 'networkia':
			cssPrefix = 'networkia-'
			break;
		case 'devecl':
		default:
			cssPrefix = "ecl-";
	}
	//classNameItemActive={`${cssPrefix}metismenu-link`}
	//menuContent.map(x => console.log(t(x.label)))
	return(
		<div id={`${cssPrefix}menubox`}>
		<MetisMenu	content={menuContent.map(x => ({label: t(x.label), to: x.to}))}
					LinkComponent={RouterLink}
					className={`${cssPrefix}metismenu`}
					classNameLink={`${cssPrefix}metismenu-link`}/>
		</div>
	)
};

export default Menu;
